<script setup>
/* eslint-disable no-undef */
defineProps({
  step: {
    type: Object,
    required: true,
    validator: (step) => {
      return step.id && step.title && step.description && step.icon;
    },
  },
});
</script>

<template>
  <div class="flex flex-col gap-4 sm:gap-6 p-4 sm:p-6 bg-white rounded-xl">
    <!-- Step Number -->
    <div class="text-left">
      <span
        class="text-3xl sm:text-4xl lg:text-5xl font-semibold text-primary-dark opacity-50 font-rubik"
      >
        Step {{ step.id }}
      </span>
    </div>

    <!-- Content -->
    <div class="flex flex-col gap-4">
      <!-- Title with Icon -->
      <div class="flex items-center gap-4">
        <div class="w-8 h-8 flex items-center justify-center">
          <svg
            class="w-6 h-6 text-primary-dark"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              :d="step.icon"
            />
          </svg>
        </div>
        <h3
          class="text-xl sm:text-2xl font-semibold text-primary-dark uppercase font-poppins"
        >
          {{ step.title }}
        </h3>
      </div>

      <!-- Description -->
      <p class="text-gray-600 text-base sm:text-lg leading-relaxed font-onest">
        {{ step.description }}
      </p>

      <!-- Learn More Link -->
      <div class="flex items-center gap-2 mt-2">
        <span
          class="text-base sm:text-lg font-semibold bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent font-rubik"
        >
          Learn More
        </span>
        <div
          class="w-6 h-6 bg-white rounded-full flex items-center justify-center shadow-sm"
        >
          <svg
            class="w-4 h-4 text-cyan-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>
